
import { muiDataGridStarted } from "../apiutils";
import { apiSlice } from "../createApiSlice";

const RELATIONADDRESS_BASE = "/relationaddress";
const buildUrl = (endpoint) => RELATIONADDRESS_BASE + endpoint;
const ApiName = "RelationAddresses";

const relationAddressApiSlice =  apiSlice.injectEndpoints({
    endpoints: builder => ({
        getRelationAddresses: builder.query({
            query: ({ args, invalidate }) => ({
                url: buildUrl(`?page=${args.page}&size=${args.size}`),
                method: 'POST',
                body: args.body,
            }),
            providesTags: (result, error, arg) => [{ type: `${ApiName}`, identifier: 'datatable'}],
            onQueryStarted: muiDataGridStarted.bind(null, 'getRelationAddresses', `${ApiName}`)
        }),
        getRelationAddress: builder.query({
            query: id => ({
                url: buildUrl(`/${id}`),
                method: 'GET'
            }),
            providesTags: (result, error, arg) => [{ type: `${ApiName}Single`, id: arg }]
        }),
        getRelationAddressSelect: builder.query({
            query: () => ({
                url: buildUrl(`/select`),
                method: 'GET'
            }),
            providesTags: (result, error, arg) => [{ type: ApiName}]
        }),
        addNewRelationAddress: builder.mutation({
            query: relationAddressInfo => ({
                url: buildUrl(`/new`),
                method: 'POST',
                body: relationAddressInfo,
            }),
            invalidatesTags: [{type: `${ApiName}`}],
        }),
        editRelationAddress: builder.mutation({
            query: relationAddressInfo => ({
                url: buildUrl(`/${relationAddressInfo.id}`),
                method: 'PUT',
                body: relationAddressInfo,
            }),
            invalidatesTags: (result, error, arg) => [{ type: `${ApiName}Single`, id: arg.id }, {type: `${ApiName}`}],
        }),
        deleteRelationAddress: builder.mutation({
            query: id => ({
                url: buildUrl(`/${id}`),
                method: 'DELETE'
            }),
            invalidatesTags: (result, error, arg) => [{ type: `${ApiName}Single`, id: arg.id }, {type: `${ApiName}`}],
        }),
    })
});

export const {
    useGetRelationAddressesQuery,
    useGetRelationAddressQuery,
    useAddNewRelationAddressMutation,
    useEditRelationAddressMutation,
    useDeleteRelationAddressMutation,
    useGetRelationAddressSelectQuery
  } = relationAddressApiSlice;
